import React from 'react';
import { Modal } from 'Modal';

export class ProducerMoreInfoLink extends React.Component {
  constructor(props) {
    super(props);

    this.toggleDialogOpen = this.toggleDialogOpen.bind(this);

    this.state = {
      dialogOpen: false,
    }
  }

  toggleDialogOpen() {
    this.setState((prevState) => ({ dialogOpen: !prevState.dialogOpen }));
  }

  render() {
    const {
      id,
      name,
      about,
      year_founded: yearFounded,
      website,
      site_product_type_pages: siteProductTypePages,
      text_logo: textLogo,
    } = this.props.producer;
    const {
      dialogOpen
    } = this.state;

    const productTypeLinks = siteProductTypePages.map((page, i) => {
      return (
        <span key={page.id}>
          { i > 0 && ', ' }
          <a href={`/${page.url}?producer=${id}`}>
            {page.title}
          </a>
        </span>
      );
    });

    return (
      <div className="producer-more-info">
        <a href="#" onClick={this.toggleDialogOpen}>
          More Info <i className="fa fa-chevron-right"></i>
        </a>
        <Modal
          isOpen={dialogOpen}
          onRequestClose={this.toggleDialogOpen}
          className="producer-more-info-dialog"
        >
          <div className="logo" dangerouslySetInnerHTML={{ __html: textLogo }} />

          <div className="info">
            <h4>Who is {name}?</h4>
            <p>{about}</p>
          </div>

          <div className="info">
            <h4>Year Founded</h4>
            <p>{yearFounded}</p>
          </div>

          <div className="info">
            <h4>Product Types Offered</h4>
            <p>{productTypeLinks}</p>
          </div>

          <div className="info">
            <h4>Website</h4>
            <p><a target="_blank" href={website}>{website}</a></p>
          </div>
        </Modal>
      </div>
    );
  }
}
